import React, { createContext, useContext, useState } from 'react'
import { Backdrop, CircularProgress } from '@mui/material'

type BackdropContextActions = {
  handleBackdropOpen: () => void
  handleBackdropClose: () => void
}

const BackdropContext = createContext({} as BackdropContextActions)

interface BackdropContextProviderProps {
  children: React.ReactNode
}

const BackdropProvider: React.FC<BackdropContextProviderProps> = ({ children }) => {
  const [openBackDrop, setOpen] = useState(false)
  const handleBackdropClose = () => {
    setOpen(false)
  }
  const handleBackdropOpen = () => {
    setOpen(true)
  }

  return (
    <BackdropContext.Provider
      value={{
        handleBackdropClose: handleBackdropClose,
        handleBackdropOpen: handleBackdropOpen,
      }}
    >
      <Backdrop
        sx={{ color: '#4F0C17', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={openBackDrop}
      >
        <CircularProgress color='inherit' />
      </Backdrop>
      {children}
    </BackdropContext.Provider>
  )
}

const useBackdrop = (): BackdropContextActions => {
  const context = useContext(BackdropContext)

  if (!context) {
    throw new Error('useBackdrop must be used within an BackdropProvider')
  }

  return context
}

export { BackdropProvider, useBackdrop }
